import Alert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
import React, { memo } from 'react';

export interface IScoutErrorAlert {
  error: Error | null;
  setError: React.Dispatch<React.SetStateAction<Error | null>>;
}

function ScoutErrorAlert(props: IScoutErrorAlert) {
  const {error, setError} = props;
  return (
    <Collapse in={!!error}>
      <Alert onClose={() => {setError(null)}} severity="error">{error ? error.message : null}</Alert>
    </Collapse>
  )
}

export default memo(ScoutErrorAlert);
